import { FC, memo } from "react";

export interface FeatureItemProps {
    feature: any;
    idx: number;
}

const FeatureItem: FC<FeatureItemProps> = ({ feature, idx }) => {
    return <div className="pb-feature" key={"featureId" + idx}>
        <div className="pb-feature-key">{feature.key}</div>
        <div className="pb-feature-value">{feature.value}</div>
    </div>
};

export default memo(FeatureItem);
